module.exports = __webpack_public_path__ + "ec337d474457c3acc63b6cf4a4ccf6be.svg";